<div class='wrapperChx wrapperChx--blueDark'>
  <!--  <mat-checkbox [(ngModel)]='value' [disabled]='disabled'>{{text}}</mat-checkbox>-->

  <meSvg [svgName]='value|getChxSvgName' (click)='disabled ? null : value=!value' [disabled]='disabled'
         [w]='chxWidth' [cur]='!disabled && cur'></meSvg>

  <span *ngIf='text'>{{ text }}</span>
</div>

